module.exports = __webpack_public_path__ + "img/inner-silence.8c5e8605.png";